import Pagination from './Pagination'

export { Pagination }
export default Pagination
